export const PRESENCELIST_SEARCH = 'PRESENCELIST_SEARCH';
export const PRESENCELIST_PAGE = 'PRESENCELIST_PAGE';
export const PRESENCELIST_MONTHSTART = 'PRESENCELIST_MONTHSTART';
export const PRESENCELIST_MONTHEND = 'PRESENCELIST_MONTHEND';
export const PRESENCELIST_YEARSTART = 'PRESENCELIST_YEARSTART';
export const PRESENCELIST_YEAREND = 'PRESENCELIST_YEAREND';
export const PRESENCELIST_USERTYPE = 'PRESENCELIST_USERTYPE';
export const PRESENCELIST_MAX = 'PRESENCELIST_MAX';